export default {
  showClass: (data, state, view,instance) => {
    var classes = {loaded:true};

    _.merge(classes,view.app.getOverlayClass(data,state,view, instance));

    if(!_.isEqual(state.app.classes,classes)) state.app.classes = classes;

    return classes;
  },
  getOverlayClass: (data,state,view,instance) => {
    var classes = {};
    var overlay = state.overlay.current;
    if(overlay !== '') classes[`overlay-${overlay}`] = true;

    return classes;
  },
  showImage: (url, format = '600x800_crop_center') => {
    var url = url;
    var dot_pos = (~-url.lastIndexOf(".") >>> 0) + 1;

    return [url.slice(0,dot_pos), `_${format}`, url.slice(dot_pos)].join('');
  },
}